import { Button } from "@mantine/core";
import type { MantineSize } from "@mantine/core";
import { Link } from "react-router-dom";
import { IconInbox } from "@tabler/icons-react";
import { useCan } from "../../hooks/useCan";
import { routePaths } from "../../lib/routePaths";

/**
 * "Request a form" CTA shown in empty / no-forms-available states so users can
 * jump to the platform-request flow (`/requests`) instead of hitting a dead end.
 *
 * Gated on `request:write` (org admins / facility managers) — the same gate as
 * the header-launcher Requests item — since only they can submit a request.
 * Renders nothing for users who can't request.
 */
export function RequestFormButton({
  size = "sm",
  variant = "light",
}: {
  size?: MantineSize;
  variant?: string;
}) {
  const canRequest = useCan("request", "write");
  if (!canRequest) return null;

  return (
    <Button
      component={Link}
      to={routePaths.requests()}
      size={size}
      variant={variant}
      leftSection={<IconInbox size={16} />}
    >
      Request a form
    </Button>
  );
}
